import React, { useState } from "react";
import { useFormik } from 'formik';
import InputField from "./formfield/InputField";
import service from "../services/anagrafica/Accessoutenteservice";
import errorSummary from "./crud/errorSummary";
import Translate from "./Translate";

function ResetForm({ token, onChangeToLogin }) {

    const [msg, setMsg] = useState(null);
    const [fine, setFine] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            password: '',
            password2: '',
        },

        onSubmit: v => {
            if (!v.password) {
                setMsg(<Translate key="PSWNONE" chiave="PSWNONE" pacchetto="Login" />);
            } else if (v.password !== v.password2) {
                setMsg(<Translate key="PSWMISMATCH" chiave="PSWMISMATCH" pacchetto="Login" />);
            } else if (v.password.length < 8) {
                setMsg(<Translate key="PSWNORULE" chiave="PSWNORULE" pacchetto="Login" />);
            } else {
                service.resetpsw(token, v).then(response => {
                    setFine(true);
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                        setMsg(errorSummary(error.response.data)?.email);
                    } else {
                        setMsg(<Translate key="PSWERRGENERIC" chiave="PSWERRGENERIC" pacchetto="Login" />)
                    }

                });
            }
        },
    });
    return (
        <form onSubmit={formik.handleSubmit} style={{
            padding: '4rem 4rem 1.5rem 1rem',
        }}>
            <div className="d-flex justify-content-between flex-column" style={{ height: '25rem' }}>
                <div>
                    <div className="d-flex justify-content-between">
                        <h1 className="h1"><Translate chiave="RESETPSW" pacchetto="Login" /></h1>
                        <div>

                        </div>
                    </div>

                    {!fine && (<>
                        <div className="mt-5">
                            <InputField
                                type="password"
                                readOnly={fine}
                                className="rotondo loginbox"
                                labelprops={{
                                    duepunti: false,
                                    style: { display: 'block' }
                                }}
                                autoFocus={true}
                                onKeyPress={() => setMsg(null)}
                                name="psw"
                                label={<Translate chiave="PSW" pacchetto="Login" />}
                                value={formik.values.password}
                                onChange={v => formik.setFieldValue('password', v.value)}
                            />
                        </div>
                        <div className="mt-5">
                            <InputField
                                type="password"
                                readOnly={fine}
                                className="rotondo loginbox"
                                labelprops={{
                                    duepunti: false,
                                    style: { display: 'block' }
                                }}
                                autoFocus={true}
                                onKeyPress={() => setMsg(null)}
                                name="psw2"
                                label={<Translate chiave="PSW2" pacchetto="Login" />}
                                value={formik.values.password2}
                                onChange={v => formik.setFieldValue('password2', v.value)}
                            />
                        </div>
                        <div className="mt-3">
                            <small>
                                <Translate chiave="PSWRULE" pacchetto="Login" />
                            </small>
                        </div>
                    </>)}
                    <div className="mt-3">
                        {msg || '\u00A0'}
                    </div>
                    {fine && (
                        <>
                            <div className="font-weight-bold"><Translate chiave="CANLOGIN" pacchetto="Login" /></div>
                            <div><Translate chiave="PSWSAVED" pacchetto="Login" /></div>
                        </>
                    )}

                </div>
                <div>
                    <div className="d-flex justify-content-between" >
                        <div>
                            <a href="/" >
                                <button
                                    onClick={onChangeToLogin}
                                    type="button"
                                    className="btn pt-0 pb-0 rotondo font-weight-semibold"
                                    style={{ color: '#000', backgroundColor: '#fff', width: '13rem' }}
                                ><Translate chiave="LOGINBACK" pacchetto="Login" /></button>
                            </a>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="btn btn-primary  rotondo text-primary p-1 font-weight-semibold"
                                style={{ backgroundColor: '#fff', width: '6.5rem' }}
                            >
                                <Translate chiave="CHANGE" pacchetto="Login" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form >
    );
}

export default ResetForm;